
// TODO : unsused ? delete

/*
An ad slot must have the following attributes:
- size = Array [ Array [2 integer: width x height] ] : accepted ads size for the slot
- withCompanion = Boolean : define if a slot must load or not an ad companion
- pos or kw = String : define the target position (pos) or keyword (kw)
- safeFrameConfig = Object : define the safe frame configuration, for example { allowPushExpansion: true }
*/


/* [size ad, size screen] */

let responsiveSizes = {
    "leaderboard": [[[1200, 150], [1190, 0]], [[840, 150], [830, 0]], [[728, 90], [718, 0]], [[320,88], [0, 0]]],
    "divider": [[[840, 150], [830, 0]], [[728, 90], [718, 0]], [[300,250], [0, 0]]],
    "article-divider": [[[728, 90], [1250, 0]], [[300,250], [0, 0]]],
    "lt-lead": [[[[1200, 150], [970, 250]], [5000, 0]], [[970, 250], [960, 0]], [[320, 88], [0, 0]]]
}

window.responsiveSizes = responsiveSizes;

const dfpFormats = {
    "outstream": { // pos 1, 9
        size: [[1,1]],
        withCompanion: false,
        safeFrameConfig: { allowPushExpansion: true }
    },
    "leaderboard": { // pos 2
        size: [[728,90]],
        responsive: "leaderboard",
        withCompanion: false,
        safeFrameConfig: {allowPushExpansion: true}
    },
    "rectangle": { // pos 3
        size: [[300,600], [300,250]],
        withCompanion: false
    },
    "mediumrectangle": { // pos 4, 6, 7
        size: [[300,250]],
        responsive: "divider",
        withCompanion: false
    },
    "article-divider": { // pos  10, 11, 12
        size: [[300,250]],
        responsive: "article-divider",
        withCompanion: false
    },
    "imu": { // 5
        size: [[300,250]],
        withCompanion: false
    },
    "background": {
        size: [],
        withCompanion: false
    },
    "lt-lead": {
        size: [[970, 250]],
        responsive: "lt-lead",
        withCompanion: false
    }
};

window.dfpFormats = dfpFormats;

// if we are on desktop we avoid lazyloading roadblock positions
const roadblockPositions = ["2", "3", "8"]; // kaching.defineSlot('rectangle', 't1', { group: 'roadblock' });


export default {
    dfpFormats,
    responsiveSizes,
    roadblockPositions
};



// WEBPACK FOOTER //
// ./js/ads/slots-config.js